import { select, Store } from '@ngrx/store';
import { ApplicationState } from '../../store/application-store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, filter, distinctUntilChanged, map } from 'rxjs';
import { selectIsMyDashboardMode } from '../../user-settings/selectors/user-settings';
import * as userSettingsActions from '../../user-settings/actions/user-settings';

@Injectable()
export class ApplicationModeService {

  isInMyDashboardMode(): Observable<boolean> {
    return this.store
      .pipe(
        select(selectIsMyDashboardMode),
        tap(x => {
        if (x == undefined) {
          this.store.dispatch(new userSettingsActions.Load());
        }
      }),
      filter(x => x !== undefined),
      distinctUntilChanged()
      );
  }

  isInMciMode(): Observable<boolean> {
    return this.isInMyDashboardMode().pipe(
      map(isInMyDashboardMode => !isInMyDashboardMode)
    );
  }

  constructor(
    private readonly store: Store<ApplicationState>
  ) { }

}
